import { useIntl } from 'react-intl';
import { ThemeProvider } from '@mui/material/styles';
import { useMaterialUIController } from 'context';
import { useThemeBuilder } from 'hook/useThemeBuilder';
import PublicLayout from 'pages/authentication/components/PublicLayout';
import ChatBox from 'pages/chatbox';
import { useDinaExternalOptions } from 'hook/useDinaExternalOptions';
import { useGetChatAssistantQuery } from 'services/assistantApi';
import IndeterminateLoading from 'components/Loading/IndeterminateLoading';
import { useNotification } from 'hook/useNotification';

export function ChatBoxPublic() {
  const { formatMessage: msg } = useIntl();
  const { addNotification } = useNotification();
  const { controller } = useMaterialUIController();
  const { primaryColor, secondaryColor } = controller;
  const { lightTheme } = useThemeBuilder(primaryColor, secondaryColor);
  const { getAssistantPublicCode, isAssistantEmbedded } = useDinaExternalOptions();
  const assistantPublicCode = getAssistantPublicCode();
  const assistantEmbedded = isAssistantEmbedded();

  const {
    data: selectedAssistant,
    isLoading,
    error: fetchAssistantError
  } = useGetChatAssistantQuery(
    {
      assistantCode: assistantPublicCode,
      isPublic: true
    },
    {
      skip: !assistantPublicCode
    }
  );

  if (fetchAssistantError) {
    if ('status' in fetchAssistantError) {
      console.error(
        `Erreur ${fetchAssistantError.status}: ${JSON.stringify(fetchAssistantError.data)}`
      );
    } else if (fetchAssistantError.message) {
      console.error(fetchAssistantError.message);
    }
    addNotification({
      type: 'error',
      title: msg({ id: 'notification.error.title' }),
      message: msg({ id: 'page.chatbox.error.assistant.error' })
    });
  }

  if (assistantPublicCode && isLoading) {
    return <IndeterminateLoading />;
  }

  return (
    <ThemeProvider theme={lightTheme}>
      <PublicLayout
        id="ChatBoxPublicLayout"
        title={msg({ id: 'assistant.title' })}
        footerDisplayed={false}
      >
        <ChatBox assistant={selectedAssistant} isPublic={true} isEmbedded={assistantEmbedded} />
      </PublicLayout>
    </ThemeProvider>
  );
}
